@if (increaseTimeDialog || changeDueDateDialog || resetFullExamDialog || partialResetExamDialog || confirmNewInstance) {
<div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
  <div class="h-full w-full flex justify-center items-center">
    <div class="items-center justify-center rounded-[16px] bg-white p-3 absolute">
      @if (increaseTimeDialog) {
      <div class="w-[400px]">
        <div class="mb-2 font-bold">
          Increase Time for Exam Part
        </div>
        <div>
          <input type="number" placeholder="Enter increase time in minutes" class="input w-full"
            [(ngModel)]="increaseTimeMinutes" />
        </div>
        <div class="text-zinc-500 my-2">
          Select which part of the exam you wish to increase time for.
        </div>
        @for (exam_part of exam_part_instances; track exam_part) {
        @if (exam_part.continue_minutes != null) {
        <div>
          Part {{exam_part.part_position + 1}} increased by {{exam_part.continue_minutes}} minutes
        </div>
        }
        }
        <select [(ngModel)]="increaseTimePartPosition"
          class="block w-full mt-2 rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
          <option [ngValue]="-1" disabled selected>Select a part</option>
          @for (part of partialResetExamPartInfo; track part) {
          <option [ngValue]="part.part_position">
            {{part.name}}
          </option>
          }
        </select>
        <div class="flex justify-between mt-5">
          <outline-button [marginRight]="true" (click)="cancelIncreaseTimeSave()" text="Cancel" />
          <full-button text="Save" (click)="increaseTimeSave()" />
        </div>
      </div>
      }
      @if (changeDueDateDialog) {
      <div class="p-2">
        <h3 class="mb-2 font-semibold">
          Change Due Date
        </h3>
        <div>
          <input [(ngModel)]="newDueDate" type="datetime-local" min="{{currentDate | date: 'yyyy-MM-ddThh:mm'}}"
            class="input" />
        </div>
        <div class="flex justify-between mt-5">
          <outline-button [marginRight]="true" (click)="cancelChangeDueDate()" text="Cancel" />
          <full-button text="Save" (click)="changeDueDateSave()" />
        </div>
      </div>
      }
      @if (resetFullExamDialog) {
      <div class="text-center max-w-96">
        <h3 class="mb-2 text-lg font-bold">
          Reset Entire Exam Instance
        </h3>
        <div class="mb-2">
          <p>Are you sure you wish to reset this exam instance?<br /><br /></p>
          <p class="text-zinc-500"><b>NOTE: </b>
            This will remove the exam instance so that the student is allowed to retake the exam from fresh.
          </p>
        </div>
        <div class="flex justify-between mt-5">
          <outline-button [marginRight]="true" (click)="cancelResetFullExam()" text="Cancel" />
          <full-button (click)="confirmResetFullExam()" text="Confirm" />
        </div>
      </div>
      }
      @if (partialResetExamDialog) {
      <div class="text-center max-w-[300px]">
        <div class="mb-2 font-bold">
          Reset Exam Instance Part
        </div>
        <div class="text-zinc-500 mb-2">
          Select which part of the exam you wish to reset.
        </div>
        <select [(ngModel)]="partialResetExamPartPosition"
          class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
          <option [ngValue]="-1" disabled selected>Select a part</option>
          @for (part of partialResetExamPartInfo; track part) {
          <option [ngValue]="part.part_position">
            {{part.name}}
          </option>
          }
        </select>
        <div class="flex justify-between mt-5">
          <outline-button [marginRight]="true" (click)="cancelPartialExamReset()" text="Cancel" />
          <full-button (click)="confirmPartialExamReset()" text="Confirm" />
        </div>
      </div>
      }
      @if (confirmNewInstance) {
      <div class="text-center">
        <h2 class="mb-2 font-bold text-lg">
          Confirm New Exam Instance
        </h2>
        <p class="mb-2 text-zinc-600">
          Are you sure you want to assign a new exam instance for
          <span class="font-bold">{{newInstanceUsername != null? newInstanceUsername : 'no name'}}?</span>
        </p>
        <p class="my-2 font-semibold">
          Optionals:
        </p>

        <div class="flex flex-col gap-1">
          <p class="text-left font-medium">
            Select Mode
          </p>
          <app-sectioned-dropdown [(selectedValue)]="newExamInstanceMode" [items]="examModeDropdownItems"
            class="mb-2 w-full"></app-sectioned-dropdown>
        </div>

        <div class="flex flex-col gap-1 mt-2">
          <p class="text-left font-medium">
            Override Due Date
          </p>
          <input [(ngModel)]="newExamInstanceOverrideDueDate" type="datetime-local"
            min="{{currentDate | date: 'yyyy-MM-ddThh:mm'}}" class="input w-full" />
        </div>


        <div class="flex justify-between mt-5">
          <outline-button [marginRight]="true" (click)="cancelNewExamInstance()" text="Cancel" />
          <full-button (click)="confirmNewExamInstance()" text="Confirm" />
        </div>
      </div>
      }
    </div>
  </div>
</div>
}
<breadcrumb [navigations]="breadcrumbNavs" endText="User Instances" />
<div class="p-2 lg:pb-2 lg:m-5">
  <h1 class="text-xl font-semibold mb-4">
    Exam Instances for {{display_name}}: {{username}}
  </h1>
  <div class="flex items-center gap-1">
    <search-input [(searchText)]="search_text" (searchTextChange)="debounceSearch()"
      placeholder="Search by exam title" />
    @if (isSearchLoading && instances.length > 0) {
    <div class="flex justify-center items-center">
      <dot-spinner />
    </div>
    }
  </div>
  <table class="mt-8 w-full lg:table-fixed border-separate border-spacing-0">
    <colgroup>
      <col class="lg:w-[28%]" />
      <col class="hidden lg:table-column lg:w-[14%]" />
      <col class="lg:w-[14%]" />
      <col class="hidden lg:table-column lg:w-[11%]" />
      <col class="hidden lg:table-column" />
      <col class="w-[72px]" />
    </colgroup>
    <thead>
      <tr class="h-[48px] text-left text-gray-500 text-xs font-semibold uppercase leading-tight">
        <th scope="col" class="bg-[#F4F6F8] rounded-l-[4px] pl-[16px] pr-2 font-semibold">
          Exam Title
        </th>
        <th scope="col" class="hidden lg:table-cell bg-[#F4F6F8] px-2 font-semibold">
          Accommodation Time
        </th>
        <th scope="col" class="bg-[#F4F6F8] px-2 font-semibold">
          Status
        </th>
        <th scope="col" class="hidden lg:table-cell bg-[#F4F6F8] px-2 font-semibold">
          Score
        </th>
        <th scope="col" class="hidden lg:table-cell bg-[#F4F6F8] px-2 font-semibold">
          Times
        </th>
        <th scope="col" class="bg-[#F4F6F8] rounded-r-[4px] pl-2 pr-[16px]">
          <span class="sr-only">Actions</span>
        </th>
      </tr>
    </thead>
    <tbody class="transition-opacity" [class.opacity-50]="isSearchLoading && instances.length > 0">
      @for (instance of instances; track instance) {
      <tr class="hover:bg-[#F9FAFB] transition-colors">
        <td class="pl-[16px] pr-2 py-3 align-middle border-b border-[#F1F3F5] text-sm">
          <button type="button" (click)="reviewInstance(instance)"
            class="block max-w-full truncate text-left font-medium text-black/90 hover:text-rutgers-red hover:underline">
            {{instance.exam.exam_title != null? instance.exam.exam_title : 'No name'}}
          </button>
        </td>
        <td class="hidden lg:table-cell px-2 py-3 align-middle border-b border-[#F1F3F5] text-sm text-black/90">
          @for (accommodation of instance.accommodations; track accommodation) {
          <div>
            @if (accommodation.time_multiplier) {
            {{accommodation.time_multiplier}}x
            }
            @if (accommodation.time_multiplier && accommodation.time_addition) {
            and
            }
            @if (accommodation.time_addition) {
            {{accommodation.time_addition}} min
            }
          </div>
          } @empty {
          <span class="text-gray-400">None</span>
          }
        </td>
        <td class="px-2 py-3 align-middle border-b border-[#F1F3F5]">
          <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap"
            [ngClass]="instance.statusClass">
            {{instance.statusLabel}}
          </span>
        </td>
        <td class="hidden lg:table-cell px-2 py-3 align-middle border-b border-[#F1F3F5] text-sm">
          @if (instance.final_score != null) {
          <span class="font-medium text-black/90">{{instance.final_score}}</span>
          @if (instance.available_score != null) {
          <span class="text-gray-500"> / {{instance.available_score}}</span>
          }
          } @else {
          <span class="text-gray-400">—</span>
          }
        </td>
        <td class="hidden lg:table-cell px-2 py-3 align-middle border-b border-[#F1F3F5] text-sm text-gray-600">
          <div class="flex items-center gap-1">
            <span class="font-medium">Start:</span>
            @if (instance.start_time != null) {
            {{instance.start_time | date: 'short'}}
            } @else {
            <span class="text-gray-400">—</span>
            }
            @if (instance.started_late) {
            <span class="rounded bg-[#FBEBEF] px-1 text-[10px] font-semibold uppercase text-[#CC0033]">Late</span>
            }
          </div>
          <div class="flex items-center gap-1">
            <span class="font-medium">Answer:</span>
            @if (instance.answer_time != null) {
            {{instance.answer_time | date: 'short'}}
            } @else {
            <span class="text-gray-400">—</span>
            }
            @if (instance.finished_late) {
            <span class="rounded bg-[#FBEBEF] px-1 text-[10px] font-semibold uppercase text-[#CC0033]">Late</span>
            }
          </div>
        </td>
        <td class="pl-2 pr-[16px] py-3 align-middle border-b border-[#F1F3F5]">
          <div class="flex items-center justify-center">
            <dropdown-menu [menuItems]="instance.menuItem" aria-label="Exam Instance Menu" appearance="outlined" />
          </div>
        </td>
      </tr>
      } @empty {
      <tr>
        <td colspan="6" class="py-10 text-center text-sm text-gray-500">
          @if (isSearchLoading) {
          <div class="flex justify-center">
            <dot-spinner />
          </div>
          } @else if (search_text) {
          No instances match "{{search_text}}"
          } @else {
          No instances found
          }
        </td>
      </tr>
      }
    </tbody>
  </table>
  @if (instances.length !== 0) {
  <full-length-pagination [(currentPagination)]="currentPagination" perPageText="Instances"
    (paginationService)="handleServiceCall()" />
  }
</div>